import { render, staticRenderFns } from "./PhysicalModelDailog.vue?vue&type=template&id=3f8bffbe&scoped=true&"
import script from "./PhysicalModelDailog.vue?vue&type=script&lang=js&"
export * from "./PhysicalModelDailog.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalModelDailog.vue?vue&type=style&index=0&id=3f8bffbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bffbe",
  null
  
)

export default component.exports